export default __webpack_public_path__ + "static/media/baleloader.99f0831e.jpg";